"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.string.trim.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uuid = require("uuid");
var _jsxFileName = "/Users/anthony.hessler/Workspace/Interactive/web-tools-io/src/lib/components/global/ToggleSwitch/index.js";
const _excluded = ["checked", "colors", "disabled", "id", "name", "onChange"];
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/**
 * @module ToggleSwitch
 */
// eslint-disable-next-line no-unused-vars
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
/**
 * Note: Styles used in-file as styled-jsx, generated from SCSS into CSS to be
 * included via an online converter.
 *
 * Source: @see {@link https://jsonformatter.org/scss-to-css}.
 */

/**
 * @typedef SwitchColors
 * @param {string} off - Color value used for the background of the component in "off" state (Default: '#cecece').
 * @param {string} on - Color value used for the background of the component in "on" state (Default: '#09c1a1').
 * @param {string} switch - Color value used for the switch toggle element (Default: '#ffffff').
 */

/**
 * Represents a reusable, flexible, customizable toggle switch input element.
 */
function ToggleSwitch(_ref) {
  let {
      checked,
      colors = {
        off: '#cecece',
        on: '#09c1a1',
        switch: '#ffffff'
      },
      disabled,
      id,
      name,
      onChange = () => {}
    } = _ref,
    passThroughProps = _objectWithoutProperties(_ref, _excluded);
  const propsClassName = passThroughProps && passThroughProps.className ? passThroughProps.className : '';
  const finalClassNames = ['toggle-switch', checked ? 'checked' : '', propsClassName].join(' ').trim();
  const testId = passThroughProps && passThroughProps['data-testid'] ? passThroughProps['data-testid'] : '';
  const uniqueUuid = (0, _uuid.v4)();
  /* istanbul ignore next */
  const finalId = id || "id-io-toggle-switch-".concat(uniqueUuid);
  /* istanbul ignore next */
  const finalName = name || "io-toggle-switch-".concat(uniqueUuid);

  /**
   * Handler function for key press event. Will also trigger component onChange.
   *
   * @param {Event} event - The Event object associated with the key press.
   */
  function handleKeyPress(event) {
    if (event.keyCode === 32) {
      event.preventDefault();
      onChange(event, !checked);
    }
  }

  /**
   * Handler function for change event. Will also trigger component onChange.
   */
  function handleChange(event) {
    onChange(event, !checked);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("style", {
    jsx: "true",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 7
    }
  }, "\n          .toggle-switch {\n            display: inline-block;\n            margin-right: 10px;\n            position: relative;\n            text-align: left;\n            user-select: none;\n            -webkit-user-select: none;\n            -moz-user-select: none;\n            -ms-user-select: none;\n            vertical-align: middle;\n            width: 50px;\n          }\n          .toggle-switch .checkbox {\n            display: none;\n          }\n          .toggle-switch .checkbox:checked + .label .inner {\n            margin-left: 0;\n          }\n          .toggle-switch .checkbox:checked + .label .switch {\n            right: 0px;\n          }\n          .toggle-switch .label {\n            border: 0 solid #ececec;\n            border-radius: 100px;\n            cursor: pointer;\n            display: block;\n            margin: 0;\n            overflow: hidden;\n          }\n          .toggle-switch .label.disabled {\n            cursor: not-allowed;\n          }\n          .toggle-switch .label > span {\n            box-shadow: 0 3px 8px 1px rgba(0, 0, 0, 0.15),\n              0 3px 1px rgba(0, 0, 0, 0.06);\n          }\n          .toggle-switch .label > span:focus {\n            outline: none;\n          }\n          .toggle-switch .label:focus {\n            outline: none;\n          }\n          .toggle-switch .inner {\n            display: block;\n            margin-left: -100%;\n            transition: margin 0.3s ease-in 0s;\n            width: 200%;\n          }\n          .toggle-switch .inner:before,\n          .toggle-switch .inner:after {\n            box-sizing: border-box;\n            color: white;\n            display: block;\n            float: left;\n            font-size: 14px;\n            font-weight: bold;\n            height: 32px;\n            line-height: 32px;\n            padding: 0;\n            width: 50%;\n          }\n          .toggle-switch .inner:after {\n            background-color: #ececec;\n            content: '';\n            padding-right: 10px;\n            text-align: right;\n            text-transform: uppercase;\n          }\n          .toggle-switch .inner:before {\n            background-color: #09c1a1;\n            color: white;\n            content: '';\n            padding-left: 10px;\n            text-transform: uppercase;\n          }\n          .toggle-switch:disabled,\n          .toggle-switch.disabled {\n            background-color: #ececec;\n            cursor: not-allowed;\n          }\n          .toggle-switch:disabled:before,\n          .toggle-switch.disabled:before {\n            background-color: #ececec;\n            cursor: not-allowed;\n          }\n          .toggle-switch .switch {\n            background: white;\n            border: 0 solid #ececec;\n            border-radius: 28px;\n            bottom: 0;\n            display: block;\n            margin: 3px;\n            position: absolute;\n            right: 16px;\n            top: 0;\n            transition: all 0.3s ease-in 0s;\n            width: 28px;\n          }\n          .inner {\n          }\n          .inner:after {\n            background: ".concat(colors.off, " !important;\n          }\n          .inner:before {\n            background: ").concat(colors.on, " !important;\n          }\n          .label {\n            border: 0 solid ").concat(colors.off, " !important;\n          }\n          .switch {\n            background: ").concat(colors.switch, " !important;\n            border: 0 solid ").concat(colors.off, " !important;\n          }\n        ")), /*#__PURE__*/_react.default.createElement("div", {
    className: finalClassNames,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 196,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    checked: checked,
    className: "checkbox",
    "data-testid": testId,
    disabled: disabled,
    id: finalId,
    name: finalName,
    onChange: handleChange,
    type: "checkbox",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 197,
      columnNumber: 9
    }
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "label".concat(disabled ? ' disabled' : ''),
    htmlFor: finalId,
    onKeyDown: handleKeyPress,
    tabIndex: disabled ? -1 : 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 207,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "inner".concat(disabled ? ' disabled' : ''),
    tabIndex: -1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 213,
      columnNumber: 11
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "switch".concat(disabled ? ' disabled' : ''),
    tabIndex: -1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 217,
      columnNumber: 11
    }
  }))));
}
ToggleSwitch.propTypes = {
  /**
   * Boolean flag denoting the checked status of the component.
   */
  checked: _propTypes.default.bool,
  /**
   * Object of color elements to use in styling and customizing switch style.
   */
  colors: _propTypes.default.shape({
    off: _propTypes.default.string,
    on: _propTypes.default.string,
    switch: _propTypes.default.string
  }),
  /**
   * Optional boolean flag denoting the disabled status of the component (Default: false).
   */
  disabled: _propTypes.default.bool,
  /**
   * The unique id of the toggle switch input element.
   */
  id: _propTypes.default.string,
  /**
   * The input name associated with the component.
   */
  name: _propTypes.default.string,
  /**
   * Handler function for the change event triggered by the component.
   */
  onChange: _propTypes.default.func
};
var _default = exports.default = ToggleSwitch;